// Decodes a JWT's payload without verifying the signature — never use this for an
// authorization decision (the backend's `authenticateAdmin` middleware is what
// actually enforces the role; a forged/expired token still gets a 401/403 there).
// This is only for UI gating: deciding whether to *show* an admin-only control, so a
// customer who manually appends `?admin=1` to the designer URL (the query flag that
// reveals the "Save as template" button) doesn't see a button that's guaranteed to
// fail for them — without a real `role:'admin'` token, this returns null and the
// button stays hidden.
export function decodeJwtRole(token: string | null): string | null {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.role === 'string' ? payload.role : null;
  } catch {
    return null;
  }
}
